import created from './attrs/created'
import data from './attrs/data'
import methods from './attrs/methods'

import { VueEditor } from "vue2-editor";

export default {
    name: 'SellingProcess',
    created,
    data,
    methods,
    components: {
        VueEditor
    }
}

